import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { ApiHandlerDiscreteParameter, HasOnError } from "@insite/client-framework/HandlerCreator";
import { Cart, CartResult, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";

export interface PlaceOrderParameter {
    jobCode: string;
    taxExemptID: string;
    receiverName: string;
    receiverPhone: string;
    paymentMethod: string;
    poNumber: string;
    vatNumber?: string;
    saveCard: boolean;
    cardHolderName: string;
    cardNumber: string;
    cardType: string;
    expirationMonth: number;
    expirationYear: number;
    securityCode: string;
    useBillingAddress: boolean;
    address1: string;
    countryId: string;
    stateId: string;
    city: string;
    postalCode: string;
    onSuccess?: (cartId: string) => void;
    payPalToken?: string;
    payPalPayerId?: string;
    isPending?: boolean;
    isAdyenDropIn?: boolean;
    adyenPspReference?: string;
    accountHolderName?: string;
    accountNumber?: string;
    routingNumber?: string;
    payerId: string;
    maskedCardNumber: string;
    antiFraudSessionId: string;
    isBnpl?: boolean;
    bnplTransactionToken?: string;
}

type HandlerType = ApiHandlerDiscreteParameter<
    PlaceOrderParameter & HasOnError,
    UpdateCartApiParameter,
    CartResult,
    {
        cartToUpdate: Cart;
    }
>;

export const PopulateApiParameterUpdated: HandlerType = props => {
    props.apiParameter = {
        cart: {
            ...props.apiParameter.cart,
            properties: {
                ...props.apiParameter.cart.properties,
                jobCode: props.parameter.jobCode,
                taxExemptID: props.parameter.taxExemptID,
                receiverName: props.parameter.receiverName,
                receiverPhone: props.parameter.receiverPhone,
            },
        },
    };
};

addToChainAfter(chain, PopulateApiParameter, PopulateApiParameterUpdated);
